import PageLoadedQueue from "../PageLoadedQueue";

/**
 * Save the comment
 *
 * @param comment
 * @param callback
 */
function saveComment(comment: string, callback: Function | null = null) {
    const saveCommentUriEl: HTMLElement = document.querySelector('div[data-save-comment-uri]');

    if (!saveCommentUriEl) {
        return;
    }

    const link = saveCommentUriEl.dataset.saveCommentUri;
    const data = {
        comment: comment,
    };

    const request = async () => {
        const response = await fetch(link, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        return response.json();
    }

    request()
        .finally(() => {
            if (callback instanceof Function) {
                callback();
            }
        });
}

/**
 * Initialize the event listeners
 *
 * @param inputElement
 */
function initCommentSavingEventListeners(inputElement: HTMLTextAreaElement) {
    inputElement.addEventListener('focus', (e) => {
        document.querySelector('.cart-footer .checkout-btn')?.classList.add('save-comment');
    }, {passive: true});

    inputElement.addEventListener('blur', (e) => {
        saveComment(inputElement.value);
    }, {passive: true});
}

/**
 * Use the moved comment input instead of the original one
 */
function syncTextAreaInputs(original: HTMLTextAreaElement, copy: HTMLTextAreaElement) {
    copy.value = original.value;
    copy.placeholder = original.placeholder;
    copy.rows = original.rows;

    original.classList.add('d-none');
    copy.classList.remove('d-none');

    copy.addEventListener('input', () => {
        original.value = copy.value;
    });
}

/**
 * Comment functionality for the checkout
 */
export function CheckoutComment() {
    const commentCheckout: HTMLTextAreaElement = document.querySelector('form#reviewAndOrder textarea#reviewAndOrder-reviewAndOrder_comment');
    const commentCheckoutMoved: HTMLTextAreaElement = document.querySelector('textarea#checkout-order-commeent-moved');

    if (commentCheckout) {
        if (commentCheckoutMoved) {
            syncTextAreaInputs(commentCheckout, commentCheckoutMoved);
            initCommentSavingEventListeners(commentCheckoutMoved);

            return;
        }

        initCommentSavingEventListeners(commentCheckout);
    }
}

/**
 * Comment functionality for the cart
 */
export function CommentCart() {
    const commentCart: HTMLTextAreaElement = document.querySelector('.shopping-cart-comment.comment');

    if (commentCart) {
        initCommentSavingEventListeners(commentCart);
    }
}

PageLoadedQueue.addFunction(CheckoutComment);
PageLoadedQueue.addFunction(CommentCart);
